<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6Tkagq/tc-custom/9781627790963.jpg?1719984692687" alt="This image is the cover for the book Just Kids From the Bronx"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Just Kids From the Bronx
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"A down-to-earth, inspiring book about the American promise fulfilled." —President Bill Clinton </b><br/><br/><b>"Fascinating . . . . Made me wish I had been born in the Bronx." —Barbara Walters</b><br/><br/><b>A touching and provocative collection of memories that evoke the history of one of America's most influential boroughs—the Bronx—through some of its many success stories</b><br/><br/>The vivid oral histories in Arlene Alda's <i>Just Kids from the Bronx</i> reveal what it was like to grow up in the place that bred the influencers in just about every field of endeavor today. The Bronx is where Michael Kay, the New York Yankees' play-by-play broadcaster, first experienced baseball, where J. Crew's CEO Millard (Mickey) Drexler found his ambition, where Neil deGrasse Tyson and Dava Sobel fell in love with science early on and where music-making inspired hip hop's Grandmaster Melle Mel to change the world of music forever.<br/>The parks, the pick-up games, the tough and tender mothers, the politics, the gangs, the food—for people who grew up in the Bronx, childhood recollections are fresh. Arlene Alda's own Bronx memories were a jumping-off point from which to reminisce with a nun, a police officer, an urban planner, and with Al Pacino, Mary Higgins Clark, Carl Reiner, Colin Powell, Maira Kalman, Bobby Bonilla, and many other leading artists, athletes, scientists and entrepreneurs—experiences spanning six decades of Bronx living. Alda then arranged these pieces of the past, from looking for violets along the banks of the Bronx River to the wake-up calls from teachers who recognized potential, into one great collective story, a film-like portrait of the Bronx from the early twentieth century until today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Arlene Alda
      </h2>
      
      <p class="authorDescription body article"><P><B>Arlene Alda</B> graduated Phi Beta Kappa from Hunter College, received a Fulbright Scholarship, and realized her dream of becoming a professional clarinetist, playing in the Houston Symphony under the baton of Leopold Stokowski. She switched careers when her children were young and became an award-winning photographer and author who has written nineteen books, including <I>Just Kids from the Bronx</I>. She is the mother of three daughters and the grandmother of eight. She and her husband, actor Alan Alda, live in New York City and Long Island.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1095505f